/** Top bar with page-agnostic controls: mobile menu toggle + admin identity. */
import { useAuth } from '../lib/auth';
import { Button } from './ui';

export function TopBar({ onMenu }: { onMenu: () => void }): JSX.Element {
  const { email, signOut } = useAuth();
  return (
    <header className="flex h-14 items-center gap-3 border-b border-slate-200 bg-white px-4 lg:px-6">
      <button
        type="button"
        onClick={onMenu}
        className="rounded-md p-2 text-slate-600 hover:bg-slate-100 lg:hidden"
        aria-label="Open menu"
      >
        ☰
      </button>
      <div className="ml-auto flex items-center gap-3">
        <div className="hidden text-right sm:block">
          <p className="text-xs font-medium text-slate-700">{email ?? 'Admin'}</p>
          <p className="text-[11px] text-emerald-600">Admin verified</p>
        </div>
        <div className="grid h-8 w-8 place-items-center rounded-full bg-slate-200 text-xs font-semibold text-slate-600">
          {(email ?? 'A').slice(0, 1).toUpperCase()}
        </div>
        <Button variant="secondary" size="sm" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
